/* eslint-disable no-use-before-define */
import React from 'react'
import { Legacy } from './legacy'
import { Main } from './main'
import { getConfig } from '../twd'

export default (args) => {
    return (getConfig('entitlements.ETradeTradeHistory', 'No') === 'Yes')
        ? <Main {...args} /> 
        : <Legacy {...args} />
}
